import * as smartadmin from './densities/smartadmin/index.js';
import * as materialFilled from './densities/material-filled/index.js';
import * as materialOutlined from './densities/material-outlined/index.js';

export const ID_SKIN_DEFAULT = 'edicom-theme-skin-default';
export const ID_DENSITY_DEFAULT = 'edicom-theme-density-default';
export const ID_SKIN = 'edicom-theme-skin';
export const ID_DENSITY = 'edicom-theme-density';
export const ID_STYLE = 'edicom-theme-style';

export const DIRECTIVE_SKIN = 'edicom-theme-skin';
export const DIRECTIVE_DENSITY = 'edicom-theme-density';
export const DIRECTIVE_MODE = 'edicom-theme-mode';
export const WATCH_DIRECTIVE = 'edicom-theme-watch';
export const DIRECTIVE_DESIGN = 'edicom-design';

export const DENSITIES = {
  smartadmin: {
    default: `/* smartadmin: default */${smartadmin.standard}`,
    compact: `/* smartadmin: compact */${smartadmin.compact}`,
    comfortable: `/* smartadmin: comfortable */${smartadmin.comfortable}`,
  },
  'material-filled': {
    default: `/* material-filled: default */${materialFilled.standard}`,
    compact: `/* material-filled: compact */${materialFilled.compact}`,
    comfortable: `/* material-filled: comfortable */${materialFilled.comfortable}`,
  },
  'material-outlined': {
    default: `/* material-outlined: default */${materialOutlined.standard}`,
    compact: `/* material-outlined: compact */${materialOutlined.compact}`,
    comfortable: `/* material-outlined: comfortable */${materialOutlined.comfortable}`,
  },
};
